import * as z from 'zod';

import { validaNomeCompleto } from '../../../../utils/ValidaNome';
import { validateBirthDate, validateCPF } from '../../../../utils/validations';
import { dependentsSchema } from './dependentesSchema';

export const AssociadoSchema = z.object({
  id: z.number(),
  name: z.string().min(1, { message: 'nome é obrigatório' }),
  birthDate: z
    .string()
    .min(1, { message: 'Campo obrigatório' })
    .regex(/^(\d{2})\/(\d{2})\/(\d{4})$/, {
      message: 'Formato inválido (use DD/MM/AAAA)',
    })
    .refine(validateBirthDate, { message: 'Data de nascimento invalida' }),
  cpf: z.string().refine(val => validateCPF(val.replace(/\D/g, '')), {
    message: 'CPF inválido',
  }),
  plano: z.string(),
  plano_vl: z.optional(z.string()),
  matricula: z.string(),
  departamentoId: z.number(),
  departamento: z.string(),
  dependentes: z.optional(z.array(dependentsSchema)),
  selecionado: z.optional(z.any()),
});
